<!--
 * @Author: your name
 * @Date: 2021-06-23 14:32:54
 * @LastEditTime: 2021-06-25 16:21:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\views\user\signIn\Integral.vue
-->
<template>
  <div class="integral-details" ref="container">
    <div class="wrapper">
      <div class="list" v-if="list.length > 0">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in list"
          :key="index"
        >
          <div>
            <div class="state">{{ item.mark }}</div>
            <div>{{ item.add_time }}</div>
          </div>
          <div class="num" v-if="item.pm == 1">+{{ item.number }}</div>
          <div class="num font-color-red" v-if="item.pm == 0">
            -{{ item.number }}
          </div>
        </div>
      </div>
      <div v-else class="number" style="margin-top: 0.4rem;text-align: center;">
        暂无数据~
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import {
  getIntegralList,
  postSignUser,
  getIntegralfgList
} from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "Integral",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      navList: [
        { name: "分值明细", icon: "icon-mingxi" },
        { name: "分值提升", icon: "icon-tishengfenzhi" }
      ],
      current: 0,
      where: {
        page: 1,
        limit: 15
      },
      type: this.$route.query.type,
      data: {
        sign: 1,
        integral: 1,
        all: 1
      },
      list: [],
      info: [],
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    this.getIntegral();
    this.getInfo();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getInfo();
    });
  },
  methods: {
    nav: function(index) {
      this.current = index;
    },
    getInfo: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      if (this.type == 1) {
        getIntegralList(that.where).then(
          res => {
            that.loading = false;
            that.loaded = res.data.length < that.where.limit;
            that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data);
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      } else if (this.type == 2) {
        getIntegralfgList(that.where).then(
          res => {
            that.loading = false;
            that.loaded = res.data.length < that.where.limit;
            that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data);
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      }
    },
    getIntegral: function() {
      let that = this;
      postSignUser(that.data).then(
        res => {
          that.info = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    }
  }
};
</script>
